export default class WS {

    constructor() {
        // this.wsUrl = 'ws://localhost:8082/ws';
        this.ws = null; //实例
        this.messageCallbacks = []; //存储各个组件的消息回调
        this.reconnectTimer = null //重连定时器标识
    };
    
    //单例模式-全局只创建一个ws实例
    static getInstance() {
        if( !WS.instance ) {
            WS.instance = new WS();
        }

        return WS.instance;
    };


    //创建连接
    init() {

        //防止重复创建连接-刷新页面就断开连接,所以此处无用  跳转页面不会断开
        if( this.ws && this.ws.readyState !== WebSocket.CLOSED) return
        // if( this.ws && this.ws.readyState === WebSocket.OPEN ) return

        //连接WebSocket(本地开发)
        // this.ws = new WebSocket("ws://localhost:8082/ws");
        //项目上线(https)
        // this.ws = new WebSocket("wss://47.254.246.82/ws");
        //项目上线(https)
        this.ws = new WebSocket("wss://woshiada.me/ws");
        

        //连接成功
        this.ws.onopen = () => {
            console.log('ws连接成功');
            //this.ws.send('hello') //发送信息到后端
        };

        //接收后端推送消息
        this.ws.onmessage = (e) => {

            const data = JSON.parse(e.data);

            // console.log('收到消息:', e.data);

            //将接收到的消息设置到onMessage


            //遍历messageCallbacks中的数据  到 data
            this.messageCallbacks.forEach(cb => {
                cb(data)
            })
            


            //语音播报
            

        };

        //连接报错
        this.ws.onerror = (e) => {
            console.error('连接报错', e)
            console.log('连接报错', e)
        };

        //连接关闭
        this.ws.onclose = (e) => {
            console.log('连接关闭', e.code);
            
            //自动重连ws
            this.reconnectTimer = setTimeout(() => {

                console.log('ws断开.... 准备重连');
                this.init();
            }, 3000)
        };


    };
    
    //注册消息回调(组件使用)
    onMessage(callback) {
        this.messageCallbacks.push(callback);
    };

    //移除消息回调
    offMessage(callback) {
        const index = this.messageCallbacks.indexOf(callback);
        if( index > -1 ) {
            this.messageCallbacks.splice(index, 1);
        }
    };

    //主动发送消息给后端
    send(msg) {

        if( this.ws.readyState === WebSocket.OPEN ) {
            
            this.ws.send(msg) //发送信息到后端
        } else {
            console.warn('ws未连接');
        }

    };

    //自动重连

    //主动关闭连接
    close() {

        //清除定时器
        clearTimeout(this.reconnectTimer);
        
        if( this.ws ) {
            this.ws.close();
        };
        
        this.messageCallbacks = [];
    }


}


